import React, { useEffect, useState, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { CardBody, CardHeader, Card, Col, Row } from 'reactstrap'
import { goBack, push } from 'redux-first-history';
import CustomSelect from '../../../../Components/Common/CustomSelect';
import MetaSvg from '../../../../assets/images/publish/meta.svg';
import { createSelector } from 'reselect';
import { getCreativesForPublish } from '../../../../slices/publish/thunk';
import { removeCreativeForPublish, selectCreativeForPublish, setFbCatalogPublishSettings, setIsBusinessAuthenticated, setPublishLoader, setSelectedCreativesPublish } from '../../../../slices/publish/reducer';
import { bytesToKB } from '../../../../slices/helper';
import CatalogSettings from './CatalogSettings';
import { getFacebookBusinessesList } from '../../../../slices/publish/facebook/thunk';
import { toggleFacebookModal } from '../../../../slices/modals/reducer';
import FacebookModal from '../FacebookModal';
import Cookies from 'js-cookie';
import { setCurrentVersion } from '../../../../slices/campaigns/reducer';
import SelectPathModal from '../../../Campaigns/Campaign/Social/Facebook/Modals/Feed/SelectPathModal';
import FeedConnection from '../../../Campaigns/Campaign/Social/Facebook/Modals/Feed/FeedConnection';

const $ = require("jquery");
$.DataTable = require("datatables.net-bs5");

function Catalog() {
  const dispatch = useDispatch();

  const selectVersionState = createSelector(state => state, state => ({
    publishTypes: state.Publish.publishTypes,
    versions: state.Campaign.versions,
    currentVersion: state.Campaign.currentVersion,
    currentCampaign: state.Campaign.currentCampaign,
    creativesForPublish: state.Publish.creativesForPublish,
    selectedCreativesPublish: state.Publish.selectedCreativesPublish,
    connectedFeed: state.Campaign.connectedFeed,
    connectedFeedName: state.Campaign.connectedFeedName,
    facebookProperties: {
      _id: state.Campaign.facebookId,
      properties: {
        title: state.Campaign.title,
        description: state.Campaign.description,
        availability: state.Campaign.availability,
        condition: state.Campaign.condition,
        price: state.Campaign.price,
        link: state.Campaign.link,
        image_link: state.Campaign.image_link,
      },
      brandId: state.Campaign.brand,
      interval: state.Campaign.interval,
      exportType: 'image',
      limit: state.Campaign.limit,
    },
    isFacebookPropertiesSet: state.Campaign.isFacebookPropertiesSet,
    facebookStatus: state.Campaign.facebookStatus,
    facebookCreativeIds: state.Campaign.facebookCreativeIds,
    userFacebookId: state.Publish.userFacebookId,
    businessList: state.Publish.businessList,
    catalogList: state.Publish.catalogList,
    fbCatalogPublishSettings: state.Publish.fbCatalogPublishSettings,
    previousLocations: state.router.previousLocations,
  }));
  const {
    publishTypes,
    versions,
    currentVersion,
    currentCampaign,
    creativesForPublish,
    selectedCreativesPublish,
    connectedFeed,
    connectedFeedName,
    facebookProperties,
    isFacebookPropertiesSet,
    facebookStatus,
    facebookCreativeIds,
    userFacebookId,
    businessList,
    catalogList,
    fbCatalogPublishSettings,
    previousLocations,
  } = useSelector(selectVersionState);
  const [versionState, setVersionState] = useState([]);

  useEffect(() => {
    if (Array.isArray(versions) && versions.length > 0) {
      setVersionState([
        { value: 'all', name: 'All Versions' },
        ...versions.map(item => { return { value: item._id, name: item.name } })
      ]);
      dispatch(setCurrentVersion(versions[0]));
    }
  }, [versions]);

  function handleGoBack() {
    // if (previousLocations[1].location.pathname.includes('facebook-authentication')) {
    dispatch(push(window.location.pathname, {
      whereToPublish: true,
      publishList: publishTypes,
      versions: versions,
      currentVersion: currentVersion,
      currentCampaign: currentCampaign,
      creatives: creativesForPublish,
      connectedFeed: connectedFeed,
      connectedFeedName: connectedFeedName,
      facebookProperties: facebookProperties,
      isFacebookPropertiesSet: isFacebookPropertiesSet,
      facebookStatus: facebookStatus,
      facebookCreativeIds: facebookCreativeIds,
      publishType: null,
      userFacebookId: userFacebookId,
      businessList: businessList,
      catalogList: catalogList,
      fbBusinessId: null,
      catalogId: null,
      selectedCreativesPublish: [],
      fbCatalogPublishSettings: false,
    }));
    // } else {
    //   dispatch(goBack());
    // }
  }

  function handleVersionChange(version) {
    const foundVersion = versions.find(item => item._id === version.value);
    dispatch(setCurrentVersion(foundVersion));
    dispatch(getCreativesForPublish(version));
  }

  async function handleSelect() {
    dispatch(setPublishLoader(true));
    await dispatch(getFacebookBusinessesList());
    dispatch(setFbCatalogPublishSettings(true));
    dispatch(setPublishLoader(false));
  }

  function checkCreativeIds() {
    // Uzunlukları kontrol et
    if (facebookCreativeIds.length !== selectedCreativesPublish.length) {
      return false;
    }
  
    // Her bir elemanı kontrol et
    for (let i = 0; i < facebookCreativeIds.length; i++) {
      if (facebookCreativeIds[i] !== selectedCreativesPublish[i]._id) {
        return false;
      }
    }
  
    return true;
  }
  

  function showFacebookModal() {
    dispatch(toggleFacebookModal());
  }

  const tableRef = useRef();
  useEffect(() => {
    if (creativesForPublish) {
      try {
        const table = $(tableRef.current).DataTable({
          data: creativesForPublish,
          columns: [
            {
              data: null,
              title: '#',
              orderable: false,
              render: (data, type, row) => {
                if (selectedCreativesPublish.some(sCreative => sCreative._id === row._id)) {
                  return "<input type='checkbox' class='form-check-input' checked />"
                } else {
                  return "<input type='checkbox' class='form-check-input' />"
                }
              }
            },
            {
              data: null,
              title: 'Version',
              render: (data, type, row) => {
                const foundVersion = versions.find(item => item._id === row.versionId);
                if (foundVersion) {
                  return foundVersion.name;
                }
              }
            },
            {
              data: null,
              title: 'Size',
              render: (data, type, row) => {
                return `<p class='m-0'>${row.size}</p>`
              }
            },
            {
              data: null,
              title: 'Publish Status',
              render: (data, type, row) => {
                if (row?.published === true) {
                  return `<span class="badge bg-success-subtle text-primary fs-11 text-uppercase">
                          <i class="ri-checkbox-circle-line align-bottom"></i> Published
                        </span>`
                } else {
                  return `<span class="badge bg-danger text-white fs-11 text-uppercase">
                              <i class="ri-close-circle-line align-bottom"></i> Not Published
                          </span>`
                }
              }
            },
            {
              data: null,
              title: 'Banner Weight',
              render: (data, type, row) => {
                return bytesToKB(row.fileSize);
              }
            },
            // {
            //   data: null,
            //   title: '',
            //   render: (data, type, row) => {
            //     return `<button class='btn btn-info btn-icon btn-sm'>
            //       <i class='ri-eye-fill'></i>
            //     </button>`
            //   }
            // }
          ],
          createdRow: (row, data, dataIndex) => {
            if (selectedCreativesPublish.some(sCreative => sCreative._id === data._id)) {
              $(row).addClass('selected-row');
            }
          },
          responsive: true,
          responsive: {
            details: {
              renderer: $.fn.dataTable.Responsive.renderer.listHiddenNodes()
            }
          },
          columnDefs: [
            { responsivePriority: 1, targets: [1, -2] },
            { responsivePriority: 2, targets: "_all" },
          ],
          language: {},
          destroy: true,
          searching: false,
          paging: false,
          info: false,
        });

        table.on('click', 'tr', function () {
          let tr = $(this).closest("tr");
          if ($(tr).hasClass("child")) {
            tr = $(tr).prev();
          }
          let data = table.row(tr).data();
          if (data) {
            if ($(this).hasClass("selected-row")) {
              $(this).removeClass("selected-row");
              $(this).find(".form-check-input").prop("checked", false);
              dispatch(removeCreativeForPublish(data));
            } else {
              $(this).addClass("selected-row");
              $(this).find(".form-check-input").prop("checked", true);
              dispatch(selectCreativeForPublish(data));
            }
          }
        });

        return function () {
          table.destroy();
        };
      } catch (error) {
        // console.log('error', error);
      }
    }
  }, [creativesForPublish, fbCatalogPublishSettings]);


  return (
    <React.Fragment>
      {fbCatalogPublishSettings ?
        <CatalogSettings />
        :
        <React.Fragment>
          <Row>
            <Col>
              <Card>
                <div className='w-100 p-3 d-flex align-items-center justify-content-between'>
                  <div className='d-flex align-items-center'>
                    <button className='btn btn-light btn-icon fw-bold' onClick={handleGoBack}>
                      <i className='ri-arrow-left-line'></i>
                    </button>
                    <CustomSelect
                      tag='button'
                      className='ms-2 btn btn-light dropdown-toggle'
                      placeholder='Select Versions'
                      options={versionState}
                      onChange={(version) => handleVersionChange(version)}
                      value={(versionState[1]?.name || '')}
                    />
                  </div>
                  <div className='d-flex align-items-center justify-content-end'>
                    {/* <img src={MetaSvg} style={{height: '30px'}} /> */}
                    <svg aria-label="Meta logo" height="30" role="img" viewBox="0 0 150 100" width="72"><defs><linearGradient gradientUnits="userSpaceOnUse" id=":r0:" x1="124.599" x2="159.703" y1="96.689" y2="57.25"><stop offset="0.21" stop-color="#0278F1"></stop><stop offset="0.533" stop-color="#0180FA"></stop></linearGradient><linearGradient gradientUnits="userSpaceOnUse" id=":r1:" x1="43.859" x2="0" y1="4.984" y2="63.795"><stop offset="0.427" stop-color="#0165E0"></stop><stop offset="0.917" stop-color="#0180FA"></stop></linearGradient><linearGradient gradientUnits="userSpaceOnUse" id=":r2:" x1="28.409" x2="134.567" y1="28.907" y2="71.769"><stop stop-color="#0064E0"></stop><stop offset="0.656" stop-color="#0066E2"></stop><stop offset="1" stop-color="#0278F1"></stop></linearGradient></defs><path d="M107.654 0c-12.3 0-21.915 9.264-30.618 21.032C65.076 5.802 55.073 0 43.103 0 18.698 0 0 31.76 0 65.376 0 86.41 10.177 99.679 27.223 99.679c12.268 0 21.092-5.784 36.778-33.203 0 0 6.539-11.547 11.037-19.501a514.1 514.1 0 0 1 4.98 8.227l7.356 12.374c14.329 23.977 22.312 32.103 36.778 32.103C140.758 99.68 150 86.23 150 64.757 150 29.56 130.88 0 107.654 0ZM52.039 59.051C39.322 78.987 34.922 83.455 27.841 83.455c-7.287 0-11.617-6.397-11.617-17.804 0-24.404 12.167-49.359 26.672-49.359 7.855 0 14.42 4.537 24.474 18.93-9.547 14.645-15.33 23.83-15.33 23.83Zm47.999-2.51-8.795-14.667c-2.38-3.87-4.66-7.428-6.862-10.689 7.927-12.234 14.465-18.33 22.241-18.33 16.155 0 29.079 23.786 29.079 53.002 0 11.137-3.647 17.599-11.205 17.599-7.244 0-10.704-4.785-24.458-26.914Z" fill="#0180FA"></path><path d="M145.119 34.888h-14.878c3.44 8.718 5.46 19.42 5.46 30.969 0 11.137-3.647 17.599-11.205 17.599-1.403 0-2.663-.18-3.884-.63V99.5a33.48 33.48 0 0 0 3.54.18C140.758 99.68 150 86.23 150 64.756c0-10.702-1.768-20.882-4.881-29.87Z" fill="url(#:r0:)"></path><path d="M43.103 0c.253 0 .505.003.756.008v16.308c-.319-.016-.64-.024-.962-.024-14.138 0-26.055 23.706-26.65 47.503H.014C.588 30.77 19.08 0 43.103 0Z" fill="url(#:r1:)"></path><path d="M43.103 0c11.115 0 20.534 5.004 31.4 17.913 3.055 3.817 6.74 8.777 10.682 14.511l.017.025.024-.003c1.939 2.912 3.94 6.05 6.017 9.428l8.795 14.668c13.754 22.13 17.214 26.913 24.458 26.913h.103v16.22c-.148.003-.297.004-.447.004-14.466 0-22.449-8.126-36.778-32.103l-7.356-12.374a587.065 587.065 0 0 0-2.287-3.822l.019-.045c-5.483-8.971-8.971-14.454-11.962-18.44l-.05.037c-9.15-12.59-15.42-16.64-22.842-16.64h-.034V.001l.24-.001Z" fill="url(#:r2:)"></path></svg>
                    {selectedCreativesPublish.length > 0 ?
                      <button className={'btn btn-info' + (isFacebookPropertiesSet ? ' btn-facebook' : ' btn-soft-facebook')} onClick={showFacebookModal}>
                        <i className='ri-facebook-fill'></i>
                      </button>
                      : null}
                    {facebookCreativeIds.length > 0 && selectedCreativesPublish.length > 0 && checkCreativeIds() && isFacebookPropertiesSet ?
                      <button className='btn btn-info ms-3' onClick={handleSelect}>
                        Select {selectedCreativesPublish.length} Creatives
                      </button>
                      : null}
                  </div>
                </div>
              </Card>
            </Col>
          </Row>
          {creativesForPublish ?
            <Row>
              <Col xxl={12} xl={12} lg={12} md={12} sm={12}>
                <Card>
                  <CardHeader>
                    Select which banners you want to publish
                  </CardHeader>
                  <CardBody>
                    <div className='table-responsive table-card mt-0 pt-2'>
                      <table
                        className="align-middle table-nowrap mb-0 table"
                        style={{ width: "100%" }}
                        ref={tableRef}
                      >
                        <thead className="table-light"></thead>
                        <tbody></tbody>
                      </table>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
            : null}
        </React.Fragment>
      }
      <FacebookModal />
      <SelectPathModal />
      <FeedConnection />
    </React.Fragment>
  )
}

export default Catalog
